import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=918a5282&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"
import style0 from "./Block.vue?vue&type=style&index=0&id=918a5282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a5282",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Block.vue
// module id = null
// module chunks = 